import { createContext, useContext, ReactNode } from "react";

interface StripeContextType {
  // Add any Stripe-related state or methods here
}

const StripeContext = createContext<StripeContextType | undefined>(undefined);

export const useStripe = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error("useStripe must be used within a StripeProvider");
  }
  return context;
};

interface StripeProviderProps {
  children: ReactNode;
}

export const StripeProvider = ({ children }: StripeProviderProps) => {
  // Add any Stripe-related state or methods here
  const value = {};

  return (
    <StripeContext.Provider value={value}>{children}</StripeContext.Provider>
  );
};
